
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";
    import { Message } from "element-ui";

    @Component({
        name: "list",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config
        // 表格数据
        tableData = [];
        // 加载状态
        loading = false;
        // 总条数
        total = 0;
        // 搜索条件
        search = {
            keyword: '',
            status: '',
            sourceType: '0',
            pagination: {
                page: 0, //页码，从0开始
                pageSize: 10, //每页数量
            },
        };


        // 新建机构
        addDialog = false
        btnloading = false
        ruleForm = {
            name: ''
        }
        rules: any = {
            name: [
                { required: true, message: '请输入产品名称', trigger: 'blur' }
            ],
            zhonglei: [
                { required: true, message: '请输入产品种类', trigger: 'change' }
            ],
            baohan: [
                { required: true, message: '请输入保函种类', trigger: 'change' }
            ]

        }
        save() {
            (this.$refs["mform"] as any).validate((valid: any) => {
                if (valid) {
                    this.btnloading = true;

                }
            });
        }
        cancle() {
            this.addDialog = false;
            (this.$refs['mform'] as any).resetFields();
        }

        add() {
            this.addDialog = true
        }

        // 查看
        toDetail(row: any) {
            this.$router.push({
                path: '/organ/organConfig',
                query: {
                    id: row.id,
                }
            })
        }
        //日志
        logDialog = false
        logTable = []
        logTotal = 0
        logSearch = {
            id: '',
            pagination: {
                page: 0,
                pageSize: 20
            }
        }
        toLog(id: any) {
            this.logSearch.id = id
            api.post('A7005', this.logSearch).then(res => {
                this.logTable = res.list
                this.logTotal = res.logTotal
                this.logDialog = true
            })
        }

        // 搜索 search:true 重置翻页
        searchTable(search = false) {
            this.loading = true;
            if (search) {
                this.search.pagination = {
                    pageSize: 20,
                    page: 0,
                };
            }
            api
                .post("A7001", this.search)
                .then((data: any) => {
                    this.total = data.total;
                    this.tableData = data.list;
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        activated() {
            this.searchTable();
            // 刷新一下字典接口
            api.getDics().then((res) => {
                store.dispatch("system/addConfig", res);
                this.config = store.state.system.config
            });
        }
    }
